module.exports = __webpack_public_path__ + "img/plus.2f538378.png";